import Layout from '@/AppInformation.vue';
const orders= {
    path: '/informations',
    name: 'Informations',
    component: Layout,
    redirect: '/informations/profile',
    children:[
        {
            path: '/informations/profile',
            name: 'Informations',
            component: () => import('@/views/informations/profile.vue'),
            meta: {title: 'Informations', auth: true, name: 'Informations', back:'/'}
        },
        {
            path: '/informations/account',
            name: 'Informations Account',
            component: () => import('@/views/informations/account.vue'),
            meta: {title: 'Informations', auth: true, name: 'Informations', back:'/'}
        },
    ]
};
export default orders;
